import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

export default class extends Controller {
  static targets = ["input", "button?"]

  connect() {
    this.mask = IMask(this.inputTarget, { mask: "+{1} (000) 000-0000" })
    if (this.buttonTarget) {
      this.buttonTarget.disabled = true
      this.mask.on(
        "accept",
        () => (this.buttonTarget.disabled = !this.mask.masked.isComplete)
      )
    }
  }

  disconnect() {
    this.mask?.destroy()
  }
}
